export const searching = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_SEARCHING', true)
    resolve()
  })
}

export const searched = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_SEARCHING', false)
    commit('SET_SEARCHED', true)
    resolve()
  })
}
